import gsap, { SplitText, ScrollTrigger } from "@lib/gsap";

export function animSplitSlideUp(element: HTMLElement) {
  let sel = gsap.utils.selector(element);

  let paragraphToSplit = sel('[data-element="slide-up-split-text"]');
  let tlArr: GSAPTimeline[] = [];

  paragraphToSplit.forEach((e) => {
    let splitPara = new SplitText(
      e.querySelectorAll('[data-element="split-target"]'),
      {
        type: "lines, words",
        mask: "lines",
        linesClass: "line",
      },
    );

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: e,
        start: "top 70%",
      },
    });

    tl.from(splitPara.lines, {
      yPercent: 100,
      stagger: 0.1,
    });

    tlArr.push(tl);
  });

  return tlArr;
}
